import { AdminGuard } from "./admin.guard";
import { AuthGuard } from "./auth.guard";
import { LoginGuard } from "./login.guard";
import { OwnerGuard } from "./owner.guard";

export * from "./admin.guard";
export * from "./auth.guard";
export * from "./login.guard";
export * from "./owner.guard";

export const appGuards = [AuthGuard, LoginGuard, AdminGuard, OwnerGuard];
